import {Concept} from 'types';
import type {WorkSummary} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import type {CreateLinkFromRowValue} from 'schema/types';
import type {VerifiedLinkedCatalogPostLink} from 'schemaDefinition/types';
import type {AgentWorkSummary} from 'services/agent/types';
import {workSummaryTableConfig} from './workSummaryTableConfig';

export const agentWorkSummaryTableConfig: TableConfiguration<AgentWorkSummary> =
  {
    ...workSummaryTableConfig,
    defaultColumns: [
      {
        name: 'roles',
        visible: true,
        width: 150,
      },
      ...(workSummaryTableConfig.defaultColumns ?? []),
    ],
  };

export const createLinkFromWorkSummaryRow: CreateLinkFromRowValue = value => {
  const link: VerifiedLinkedCatalogPostLink = {
    type: Concept.work,
    linkStatus: 'verified',
    entityId: (value as WorkSummary).id,
    name: 'title',
  };
  return link;
};
